import { CrudService } from '../base/CrudService';
export class RequestApprovalService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestApprovalService.DEFAULT_SERVICE_PATH,
            basePath: RequestApprovalService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestApprovalService.DEFAULT_SERVICE_PATH = 'procurements';
RequestApprovalService.BASE_PATH = 'api/requestapproval';
//# sourceMappingURL=RequestApprovalService.js.map